// react
import React, { useEffect } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import TextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Select from 'react-select';
import { ValidSelect } from "beaktShared/helpers/validselect";

// services
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbersStart1 } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/pagamentoDinheiro.js";
const useStyles = makeStyles(styles);

export default function PagamentoOutros({ pgto, CallloadTotalizadorPgtosOutros, formaOutros }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const {register, errors, handleSubmit, setValue, clearError} = useForm({mode: "onBlur"});

  const [messageReturn, setmessageReturn] = React.useState({
    show: false,
    message: ''
  });

  useEffect(() => {
    if (formaOutros.length === 1) {
      handleTipoChange(formaOutros[0].descricao);
    }
  }, []);

  const [tipoOutros, settipoOutros] = React.useState(null);
  const [possuiObservacao, setpossuiObservacao] = React.useState(false);
  const [beaktPix, setbeaktPix] = React.useState(false);
  const [botaoLancarPagamento, setBotaoLancarPagamento] = React.useState(true);

  const handleTipoChange = (e) => {
    setbeaktPix(false);
    setpossuiObservacao(false);
    settipoOutros(e);
    setValue("valor", "", false);
    setValue("observacao", "");
    setBotaoLancarPagamento(true);
    setmessageReturn({show: false});

    if (e.descricao !== "")
      clearError("tipo");

    // Alterado para exibir campo Observação para todas formas de pagamentos (#112480)
    if (e.ativo === true) {
      setpossuiObservacao(true);
    }

    if (e.gateway == "Beakt Pix") {
      setValue("valor", transformValueFloattoFormated(pgto.totalizadorPagamentos.valorPendente), true);
      setbeaktPix(true);
    }
    if (e.descricao === "Venda Financeira") {
      setpossuiObservacao(true);
      setValue("observacao", "Parcelamento em até 48x");
    }
  };

  const [LoadingForm, setLoadingForm] = React.useState(false);

  const onSubmit = async (data, e) => {
    e.preventDefault();
    setLoadingForm(true);
    let valor = transformValueFormatedtoFloat(data.valor);
    let observacao = data.observacao;

    if (valor > pgto.totalizadorPagamentos.valorPendente.toFixed(2)) {
      setmessageReturn({
        show: true,
        tipo: 'erro',
        message: t('error_message.the_amount_must_be_equal_or_less_than_the_balance_to_pay')
      });
      setLoadingForm(false);
      return;
    }

    setmessageReturn({show: false});
    finalizarPagamento(data, valor, observacao);
  };

  const clearForm = () => {
    settipoOutros(null);
    setValue("tipo", "");
    setValue("observacao", "");
    setpossuiObservacao(false);
  };

  const finalizarPagamento = (data, valor, observacao) => {
    let numParcelas = data.parcelas ?? 1;
    let descParcelas =
      numParcelas > 1
        ? `${numParcelas} Parcelas`
        : "1 Parcela";

    if (data.parcelas && parseInt(data.parcelas) > 1) {
      let valorParcela = valor / parseInt(data.parcelas);
      descParcelas = data.parcelas + "x " + transformValueFloattoFormated(valorParcela);
    }

    let pg = {
      id: pgto.pagamentos.length + 1,
      tipo: 4,
      descricaoFormaPgto: tipoOutros.descricao,
      gateway: tipoOutros.gateway,
      valor: valor,
      descTipo: tipoOutros.descricao,
      parcela: numParcelas,
      observacao: observacao,
      descPacela: descParcelas,
      orderId: '',
    };

    let updatepgto = {
      ...pgto,
      pagamentos: [
        ...pgto.pagamentos,
        pg
      ]
    };

    clearForm();
    setLoadingForm(false);
    CallloadTotalizadorPgtosOutros(updatepgto);
  };

  return (
    <div style={{ paddingBottom: '30px' }}>

      <form onSubmit={handleSubmit(onSubmit)}>
        {formaOutros.length >= 1 &&
          <GridContainer className={classes.containerin}>
            <GridItem xs={12} sm={3} md={3}>
              <div className={classes.labelIdent}>
                {t('sale.type')} *
              </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <div className="removeScroll">
                <Select
                  styles={ValidSelect(errors.tipo ? true : false)}
                  classNamePrefix="select"
                  isSearchable={true}
                  name="tipo"
                  placeholder={t('label.select') + "..."}
                  options={formaOutros}
                  value={tipoOutros != null && formaOutros.filter(({formaPagamentoId}) => formaPagamentoId === tipoOutros.formaPagamentoId)}
                  getOptionLabel={({descricao}) => descricao}
                  getOptionValue={({formaPagamentoId}) => formaPagamentoId}
                  onChange={(value) => handleTipoChange(value)}
                  ref={() => register({name: "tipo"})}
                />
              </div>
              <FormHelperText className={classes.labelRootError}>
                {errors.tipo && <span className="obg"> {t('label.required')} </span>}
              </FormHelperText>
            </GridItem>
          </GridContainer>
        }
        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.value')} *
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{shrink: true}}
              defaultValue=""
              name="valor"
              disabled={beaktPix}
              InputProps={{inputComponent: MaskMoney}}
              inputRef={register({required: true})}
              error={errors.valor ? true : false}
            />
            <FormHelperText>
              {errors.valor && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.containerin}>
          {
            possuiObservacao &&
            (
              <>
                <GridItem xs={12} sm={3} md={3} style={{marginLeft: '-8px'}}>
                  <div className={classes.labelIdent}>
                    {t('label.observation')}
                  </div><br></br>
                </GridItem>
                <div style={{textAlign: 'center'}}>
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{shrink: true}}
                      defaultValue=""
                      className="inputObs"
                      name="observacao"
                      inputProps={{maxLength: 100}}
                      multiline
                      rows={4}
                      style={{width: '279px', marginLeft: '7px'}}
                      inputRef={register({required: false})}
                      error={errors.observacao ? true : false}
                    />
                  </GridItem>
                </div>
              </>
            )
          }
        </GridContainer>

        <GridContainer className={classes.containerin}>
          <GridItem xs={12} sm={12} md={12}>
            {
              messageReturn.show &&
              <div className={`alertmax ${messageReturn.tipo === 'erro' ? 'alertErrorEx' : 'alertEx'}`}>
                <p>
                  {messageReturn.message}
                </p>
              </div>
            }
          </GridItem>
        </GridContainer>

        {
          botaoLancarPagamento &&
          (
            <GridContainer className={classes.containerin}>
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ minHeight: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {LoadingForm ? (
                    <CircularProgress size={30} />
                  ) : (
                    <Button type="submit" color="primary">
                      {t('button.post_payment')}
                    </Button>
                  )}
                </div>
              </GridItem>
            </GridContainer>
          )
        }
      </form>

    </div>
  );
}
